<template>
    <div class="form-page">
        <my-form v-model="form" readonly table>
            <my-form-item-group title="澄清问题">
                <el-form-item label="提交人名称" prop="addusername" class="table-full-row">
                    {{form.addusername||'-'}}
                </el-form-item>
                 <el-form-item label="问题标题" class="table-full-row">

                    {{form.yqcqwttitle||'-'}}
                </el-form-item>
                <el-form-item label="问题内容" prop="yqcqwt"  class="table-full-row">
       
                    <el-input v-html="form.yqcqwt"  type="textarea" :rows="4"></el-input>
                </el-form-item>
               <el-form-item label="最晚回复时间" prop="zwhfsj"  class="table-full-row">
                    {{form.zwhfsj||'-'}}
                </el-form-item>
               
               <el-form-item label="附件" class="table-full-row">
                    <my-upload readonly  :file-guid="form.fileguid||''"></my-upload>
                </el-form-item> 
            </my-form-item-group>
            <my-form-item-group title="回复问题">
                <el-form-item label="回复内容" prop="exthfcontent" class="table-full-row">
                     <el-input v-html="form.exthfcontent"  type="textarea" :rows="4"></el-input>
                </el-form-item>
                 <el-form-item label="附件" class="table-full-row">
                    <my-upload readonly  :file-guid="form.exthffileguid||''"></my-upload>
                </el-form-item> 
            </my-form-item-group>
        </my-form>
    </div>
</template>
     
<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
export default {
    mixins: [LIST_PAGE_MIXIN],
     props: {
        data:{
            type: Object,
            default: () => ({})
        },
        
    },
    data() {
        return{
            form:{
                fileguid:'',
                exthffileguid:''
            }
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {


    },
    created() {
         this.$get(`${this.getGetters('bidUrl')}/pingbiao/zgscCqwt/hfdetail.json`, {
            id:this.data.wtcode,
            bdid:this.getQuery('bdcode'),
        }, data => {
            this.form=data.model;
        });
        
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">

</style>
